<template>
  <AccountStatement :isSales="true" />
</template>
  
  <script>
import AccountStatement from "../shared/AccountStatement.vue";
export default {
  components: {
    AccountStatement,
  },
};
</script>
  
  <style>
</style>